import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { Page } from '../../../../../app/page-url-path';
import type { IModelBasedOnEnrollmentStatus } from '../../../../../dotcms/dotcms-models/model-based-on-enrollment-status-helper';
import { useEnrollmentPeriodOpenInfo } from '../../../../../hooks/use-get-periods-info/use-enrollment-period/use-enrollment-period-open-info';
import { useGetUserStatesInEnrollment } from '../../../../../hooks/use-get-user-states-in-enrollment';

const useReadyToEnrollModule = () => {
  const muiTheme = useTheme();
  const userStates = useGetUserStatesInEnrollment();
  const { isEnrollmentOrScheduledEnrollmentOpen } =
    useEnrollmentPeriodOpenInfo();

  const buttonPages: IModelBasedOnEnrollmentStatus<Page> = useMemo(
    () => ({
      defaultData: Page.ACCOUNT_PAGE,
      ifEnrollmentIsAvailableData: Page.ENROLLMENT_PAGE,
      ifInEsppButNotInCashless: Page.ENROLLMENT_PAGE,
      ifEnrollmentIsClosedData: Page.ACCOUNT_PAGE,
      ifAlreadyEnrolledData: Page.ACCOUNT_PAGE,
    }),
    [],
  );

  return useMemo(
    () => ({
      muiTheme,
      buttonPages,
      userStates,
      isEnrollmentOrScheduledEnrollmentOpen,
    }),
    [muiTheme, buttonPages, userStates, isEnrollmentOrScheduledEnrollmentOpen],
  );
};

export default useReadyToEnrollModule;
